interface LiveAvatarImageProps {
  src?: string;
  name?: string;
  className?: string;
}

const getAvatarInitial = (name?: string): string => {
  const source = name?.trim() ?? '';

  return source ? source.slice(0, 1).toUpperCase() : 'A';
};

export function LiveAvatarImage({ src, name, className = 'size-10' }: LiveAvatarImageProps) {
  return (
    <div
      className={`relative shrink-0 overflow-hidden rounded-full border border-white/15 bg-white/[0.06] ${className}`}
    >
      {src ? (
        <>
          <img
            src={src}
            alt=""
            aria-hidden
            className="absolute inset-0 h-full w-full scale-110 object-contain blur-2xl"
          />
          <img src={src} alt={name ?? ''} className="relative z-10 h-full w-full object-contain" />
        </>
      ) : (
        <span className="flex h-full w-full items-center justify-center font-semibold text-white/80">
          {getAvatarInitial(name)}
        </span>
      )}
    </div>
  );
}
